import { api } from "@/lib/api";

export const pushSupported = () => "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;

const urlBase64ToUint8Array = (base64String) => {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
};

export const getSubscription = async () => {
  if (!pushSupported()) return null;
  const reg = await navigator.serviceWorker.ready;
  return reg.pushManager.getSubscription();
};

export const enablePush = async () => {
  if (!pushSupported()) throw new Error("Notifications non supportées sur cet appareil");
  const permission = await Notification.requestPermission();
  if (permission !== "granted") throw new Error("Notifications refusées dans le navigateur");
  const { data } = await api.get("/push/public-key");
  const reg = await navigator.serviceWorker.ready;
  const sub =
    (await reg.pushManager.getSubscription()) ||
    (await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: urlBase64ToUint8Array(data.public_key) }));
  await api.post("/push/subscribe", sub.toJSON());
  return sub;
};

export const disablePush = async () => {
  const sub = await getSubscription();
  if (!sub) return;
  await api.post("/push/unsubscribe", sub.toJSON()).catch(() => {});
  await sub.unsubscribe();
};
